<app-network-status></app-network-status>
<router-outlet></router-outlet>
